/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Styles, StyledButton } from './styles';
import BreadcrumbComponent from '../../ui/Breadcrumb';
import FormInput from '../../ui/FormInput';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { Course } from '../../../types/schema';
import { GenericError } from '../../../styles/error';
import FormCheck from '../../ui/FormCheck';
import { FaLink } from 'react-icons/fa';
import router from 'next/router';
import { toast } from 'react-toastify';
import { imageConstraints } from '../../../utils/constraints';
import { UserData } from '.';
import ClientComponent from '../../ui/ClientComponent/ClientComponent';

export type RegisterPageTemplateProps = {
  course: Course;
  bannerTitle: string;
  title?: string;
  bannerImg?: string;
  captchaRef?: React.MutableRefObject<ReCAPTCHA | null>;
  sitekey?: string;
  onSubmit?: (data: IFormInputs, e: React.BaseSyntheticEvent<object, any, any> | undefined) => void;
  setCaptcha?: (value?: string | null) => void;
  error: {
    field: string;
    message: string;
  };
  loading: boolean;
  success: boolean;
  userData: UserData | null;
};

export interface IFormInputs {
  name: string;
  email: string;
  tel: string;
  newsletter: boolean;
}

const RegisterPageTemplate: React.FC<RegisterPageTemplateProps> = ({
  bannerTitle,
  title,
  bannerImg,
  error,
  captchaRef,
  sitekey,
  setCaptcha,
  onSubmit,
  course,
  loading,
  success,
  userData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInputs>();

  function copyText(link: string) {
    const url = link;
    const modifiedURL = url.replace(/\/pre-inscricao$/, '');
    navigator.clipboard.writeText(modifiedURL);
    toast.success('Link copiado!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper registration-page">
        <BreadcrumbComponent
          title={course.title}
          image={bannerImg || imageConstraints['Home-Hero']}
        />
        <section className="registration-area">
          <Container>
            <Row>
              <Col md="12">
                <div className="registration-box">
                  <div className="registration-title text-center mb-3">
                    <h3>{title || bannerTitle}</h3>
                  </div>
                  {!course.preSubscription && course.paymentUrl && (
                    <div className="info">
                      Após informar os dados abaixo você{' '}
                      <b>será redirecionado para o Mercado Pago</b> onde realizará o pagamento. Ao
                      concluir o pagamento, em algumas horas enviaremos mais informações.
                    </div>
                  )}
                  {!success ? (
                    <form
                      className="form"
                      name="form"
                      onSubmit={onSubmit && handleSubmit((data, e) => onSubmit(data, e))}
                    >
                      <FormInput
                        defaultValue={userData?.name}
                        type="text"
                        label="Nome"
                        placeholder="Nome"
                        name="name"
                        errors={errors['name']}
                        register={register('name', {
                          required: 'Por favor informe seu nome.',
                          minLength: { value: 3, message: 'Deve ter ao menos 3 caracteres.' },
                        })}
                      />
                      <FormInput
                        defaultValue={userData?.email}
                        type="email"
                        label="E-mail"
                        placeholder="E-mail"
                        name="email"
                        errors={errors['email']}
                        register={register('email', { required: 'Por favor informe seu email.' })}
                      />
                      <FormInput
                        defaultValue={userData?.phone}
                        type="tel"
                        label="Telefone"
                        placeholder="Telefone"
                        name="tel"
                        mask="(99) 9 9999-9999"
                        errors={errors['tel']}
                        register={register('tel', { required: 'Por favor informe seu telefone.' })}
                      />
                      <FormCheck
                        label="Receber novidades do Academy e da App Masters"
                        name="newsletter"
                        register={register('newsletter')}
                      />
                      <ClientComponent>
                        <div className="my-4 recaptcha-area text-center">
                          <ReCAPTCHA sitekey={sitekey!} onChange={setCaptcha} ref={captchaRef} />
                        </div>
                      </ClientComponent>
                      {error?.field && error?.message && (
                        <GenericError className="my-4 text-center">{error?.message}</GenericError>
                      )}

                      <StyledButton className="mb-3" type="submit" disabled={loading}>
                        CONFIRMAR
                        {loading && <div className="spinner-border" role="status"></div>}
                      </StyledButton>
                    </form>
                  ) : (
                    <div className="registration-success">
                      {course.preSubscription ? (
                        <div className="registration-success-message">
                          <p className="text-end mb-3">
                            Sua pré-inscrição foi realizada com sucesso!
                          </p>
                          <p className="text-end mb-3">
                            Assim que tivermos informações sobre abertura de uma nova turma te
                            avisaremos por email e whatsapp.
                          </p>
                          <p className="text-end mb-3">
                            Enquanto isso, convide 🙏 seus amigos para se pré-inscrever, acelerando
                            nosso processo de abertura de turma.
                          </p>
                        </div>
                      ) : (
                        <div className="registration-success-message">
                          <p className="text-end mb-3">Sua inscrição foi realizada com sucesso!</p>
                          <p className="text-end mb-3">
                            Assim que tivermos informações sobre abertura de uma nova turma te
                            avisaremos por email e whatsapp.
                          </p>
                          <p className="text-end mb-3">
                            Que tal convidar seus amigos para participar contigo deste treinamento?
                            Basta copiar o link abaixo e compartilhar.
                          </p>
                        </div>
                      )}

                      <div className="registration-success-actions">
                        <StyledButton type="button" onClick={() => copyText(window.location.href)}>
                          Copiar Link
                          <div className="button-icon">
                            <FaLink />
                          </div>
                        </StyledButton>
                        <StyledButton type="button" onClick={() => router.push('/cursos')}>
                          Ver todos os cursos
                        </StyledButton>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Styles>
  );
};

export default RegisterPageTemplate;
